/**
 * Basic Profile category config
 *
 * KPIs: roName, stateName, districtName, city, constituencyName,
 *       sponsoredBy, isPMShree, buildingType, openingYear,
 *       cbseAffliation, stationType
 */
import type { CategoryConfig } from './CategoryConfig';

export const basicProfileConfig: CategoryConfig = {
  categoryKey: 'basicProfile',
  label: 'Basic Profile',
  priority: 1,

  columns: {
    defaultVisibleColumns: [
      'schoolName', 'stateName', 'roName', 'districtName', 'city',
    ],
    hideColumns: ['schoolID', 'latitude', 'longitude'],
  },

  // Standard single-select KPI dropdown, fetched from API — no overrides needed.
};
